import { PluginRegistrationProps } from "./register-plugins";

export class TextTemplateButtonInfo {
  text: string = "";
  template: string = "";
}

export default function TextTemplateButtonPlugin({ editor }: PluginRegistrationProps) {
  let templateButtons: TextTemplateButtonInfo[] = editor.getParam("template_buttons");
  if (!!templateButtons && templateButtons.length > 0) {
    templateButtons.forEach((ti, index) => {
      editor.ui.registry.addButton(`templatebutton_${index + 1}`, {
        text: ti.text,
        onAction: () => editor.insertContent(ti.template)
      });
    });
  }
};

